<template>
  <v-row class="ma-0">
    <v-col cols="12" class="pa-0">
      <div class="plan-title-wrap">
        <span class="plan-title">
          연차계획 {{ planCount }}
          <span class="divider point-blue"> {{ planObj.closeDay }}일 </span>
        </span>
        <v-btn
          v-if="planObj.btnApp === '0'"
          class="ml-auto"
          color="darkGrey"
          elevation="0"
          @click="toApplication"
        >
          <span class="white--text">계획신청</span>
        </v-btn>
      </div>
    </v-col>
    <v-col cols="12" class="pt-5 pb-10 px-6">
      <div class="d-flex">
        <span class="plan-title view-label">근태종류</span>
        <span class="plan-desc view-desc ml-auto">
          {{ planObj.codeObj.codeNm }}
        </span>
      </div>
      <div class="pt-2 d-flex">
        <span class="plan-title view-label">사용일</span>
        <span class="plan-desc view-desc ml-auto">{{ planDate }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';

export default {
  props: {
    planObj: Object,
    index: Number,
  },
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('CODE', ['GET_GNT_CD_OBJ']),

    planCount() {
      const index = this.index + 1;
      return index < 10 ? '0' + index : index;
    },

    planDate() {
      return this.planObj.sYmd === this.planObj.eYmd
        ? this.planObj.sYmd
        : this.planObj.sYmd + ' ~ ' + this.planObj.eYmd;
    },
  },
  methods: {
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP']),
    ...mapMutations('ELA', [
      'RESET_ELA_STATE',
      'RESET_APPLICATION_STATE',
      'SET_S_YMD',
      'SET_E_YMD',
      'SET_GNT_GUBUN_CD',
      'SET_GNT_CD',
      'SET_HALF_YN',
      'SET_APP_MENU',
      'SET_CLOSE_DAY',
    ]),

    /* 데이터 셋팅 후 신청서(추가 옵션 화면)로 이동 */
    async toApplication() {
      this.$store.commit('SPINNER/ON_APP_SPINNER');

      // store 초기화
      this.RESET_ELA_STATE();
      this.RESET_APPLICATION_STATE();

      // 기본정보 조회
      const searchApplCd = '22'; // 근태
      const gntGubunCd = '1'; // 연차
      const initParams = {
        searchApplCd,
        adminYn: 'N',
        authPg: 'A',
        searchApplSeq: null,
        searchApplSabun: this.GET_USER_DATA.ssnSabun,
        searchApplInSabun: this.GET_USER_DATA.ssnSabun,
        searchApplStatusCd: '21', // 신청
        searchApplYmd: dayjs().format('YYYYMMDD'),
      };
      try {
        await this.$store.dispatch('ELA/FETCH_ELA_APPL_INFO', initParams);
        this.SET_APP_MENU({ applCd: searchApplCd, gntGubunCd });
        this.SET_GNT_GUBUN_CD(gntGubunCd);

        // 일자로 신청가능 여부 확인
        this.SET_GNT_CODE_TMP(this.planObj.codeObj.code);
        this.SET_GNT_CD(this.GET_GNT_CD_OBJ);
        this.SET_S_YMD(this.planObj.sYmd.replaceAll('-', ''));
        this.SET_E_YMD(this.planObj.eYmd.replaceAll('-', ''));
        const result = await this.$store.dispatch('ELA/VALIDATE_VACATION_DET');
        if (result) {
          this.SET_HALF_YN();
          await this.$store.dispatch('ELA/FETCH_HOLI_CNT');
          await this.$store.dispatch('ELA/FETCH_REST_CNT');

          // 추가옵션 화면으로 이동
          this.$router.push(routerNames.ExtraOptions);
        }

        this.$store.commit('SPINNER/OFF_APP_SPINNER');
      } catch (error) {
        alert(error);
      }
    },
  },
};
</script>

<style></style>
